export default {
  userGroups: [],
  status: {},
  existingAccountUsers: []
};